"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:5.1.3'] && _();
}
catch (e) { }
